import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAllFn = () => restHelpers.withBearer.get(`${K.API_URL}/communications`, {});

const getByLeadFn = leadId => restHelpers.withBearer.get(`${K.API_URL}/communications?leadId=${leadId}`, {});

const getIncomingFn = () => restHelpers.withBearer.get(`${K.API_URL}/communications?direction=in`, {});

const setReadByLeadFn = leadId => restHelpers.withBearer.put(`${K.API_URL}/communications/read/${leadId}`, {});

const setNotifiedFn = () => restHelpers.withBearer.put(`${K.API_URL}/communications/notified`, {});

const getSystemCreatedFn = () => restHelpers.withBearer.get(`${K.API_URL}/notifications/created`, {});

const setReadFn = () => restHelpers.withBearer.put(`${K.API_URL}/communications/read`, {});

const setSystemReadFn = () => restHelpers.withBearer.put(`${K.API_URL}/notifications/read`, {});

export default {
  getAll: getAllFn,
  getIncoming: getIncomingFn,
  setReadByLead: setReadByLeadFn,
  setNotified: setNotifiedFn,
  getByLead: getByLeadFn,
  getSystemCreated: getSystemCreatedFn,
  setRead: setReadFn,
  setSystemRead: setSystemReadFn
};



// WEBPACK FOOTER //
// ./src/services/communications.js